import { useState } from 'react';
import { useDebounce } from 'react-use';

export function debounce(f, ts = 300) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => f(...args), ts);
  };
}

export function useDebouncedValue(val, t = 300) {
  const [debouncedValue, setDebouncedValue] = useState(val);

  useDebounce(
    () => {
      setDebouncedValue(val);
    },
    t,
    [val]
  );

  return debouncedValue;
}

export function throttle(f, ts = 300) {
  let last = 0;
  return (...args) => {
    const now = Date.now();
    if (now - last < ts) return;
    last = now;
    f(...args);
  };
}

export function noop() {}
